<div class="add-blog-container">
  <div class="form-section">
    <div class="top-section">
      <div class="title">Add a new Blog</div>
      <div class="sub-title">
        <!-- Lorem ipsum, dolor sit amet consectetur adipisicing. -->
      </div>
    </div>
    <div class="form" [formGroup]="blogForm">
      <input
        name="title"
        [ngClass]="{
          'error-border': blogForm.get('title').value == '' && submitted
        }"
        formControlName="title"
        autocomplete="off"
        placeholder="title"
      />
      <textarea
        name="description"
        id=""
        formControlName="description"
        cols="30"
        rows="10"
        placeholder="description"
      ></textarea>
      <input
        type="file"
        (change)="onFileUpload($event)"
        [ngClass]="{
          'error-border': blogForm.get('file').value == '' && submitted
        }"
        autocomplete="off"
        placeholder="password"
      />
      <button type="submit" (click)="onUpload()" *ngIf="!isLoading">
        Upload
      </button>
      <button type="submit" (click)="onUpload()" *ngIf="isLoading">
        Uploading
        <i class="fa-solid fa-spinner fa-spin"></i>
      </button>
      <small class="required-error" *ngIf="submitted && blogForm.invalid"
        >Please enter required fields!</small
      >
    </div>
  </div>
  <div class="img-section">
    <img src="../../../assets/images/icon 07.png" alt="" />
  </div>
</div>
